import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CoreModule } from '@shared/@modules/@core/core.module';

interface FormErrorMessage {
  required?: string;
  min?: string;
  minlength?: string;
  max?: string;
  maxlength?: string;
  notOnlySpaces?: string;
  textContainsNumbers?: string;
  email?: string;
  arabicPattern?: string;
  englishPattern?: string;
  digits?: string;
  passwordComplexity?: string;
}

@Component({
  selector: 'app-form-error',
  imports: [CoreModule],
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss',
})
export class FormErrorComponent {
  control = input.required<FormControl>();
  messages = input<FormErrorMessage>();
}
